import _ from "lodash";
import moment from "moment-timezone";
import { checkCheckinTimeWindow } from "@/modules/checkin-facility/utils/checkinTimeWindow";
import t from "typy";

import {
  booking_status,
  main_form_methods,
  payment_status
} from "../../../utils/mockup";

import { eventBus } from "@/main";
import loader from "@/services/loader";
import { BIconCloudSnowFill, BIconTelephoneInbound } from "bootstrap-vue";
import { iteratee, times } from "lodash";
import DateDropdown from "vue-date-dropdown";
import Datepicker from "vuejs-datepicker";
import { mapActions, mapState } from "vuex";
import LanguageButtonComponent from "../../dashboard/components/language-button.component";
import LeaveWarningModal from "../components/LeaveWarningModal.vue";
import GuideComponent from "./../../../components/guide.component";
import TermsComponent from "./../../../components/terms.component";
import OptIn from "./../components/OptIn.vue";
import ConfirmationSeparatelyModal from "./../components/confirmationSeparatelyModal";
import GatewayPayment from "./../components/gatewayPayment.vue";
import localizedFilter from "./../components/localizedFilter";
import preCheckinBookingDetails from "./../components/preCheckinBookingDetails";
import preCheckinCustomForm from "./../components/preCheckinCustomForm";
import SelectOptionModal from "./../components/selectOptionModal";
import CheckinByName from "./checkin_by_name_component.vue";
import CheckinByPciHub from "./checkin_by_pci_hub_component.vue";
import CheckinByPhone from "./checkin_by_phone_component.vue";
import CheckinKioskHub from "../kiosk/checkin_kiosk_hub_component.vue";
import KioskIdleWarningModal from "../kiosk/KioskIdleWarningModal.vue";
import kioskValidationMixin from "../kiosk/kiosk_validation_mixin";
import { KIOSK_FLOWS, isKioskRoute } from "../kiosk/kiosk_config";
import { applyKioskLanguage, rememberKioskLanguage } from "../kiosk/kiosk_language";
import AgeComponent from "./form-components/AgeComponent";
import BodyTemperatureComponent from "./form-components/BodyTemperatureComponent";
import CoreChoicesComponent from "./form-components/CoreChoicesComponent";
import DefaultComponent from "./form-components/DefaultComponent";
import DobComponent from "./form-components/DobComponent";
import EmailComponent from "./form-components/EmailComponent";
import GenderComponent from "./form-components/GenderComponent";
import GovIdComponent from "./form-components/GovIdComponent";
import MealComponent from "./form-components/MealComponent.vue";
import MultipleRoomComponent from "./form-components/MultipleRoomComponent";
import NationalityComponent from "./form-components/NationalityComponent";
import SignatureComponent from "./form-components/SignatureComponent";
import VaccineCardComponent from "./form-components/VaccineCardComponent";
import RelationshipComponent from "./form-components/companion/RelationshipComponent";
import CheckinTimeRestriction from "../components/CheckinTimeRestriction.vue";


const {
  getChoice,
  formatDate,
  loadAgeDropdown,
} = main_form_methods;

const sections = ["visit_info", "sanitation", "others"];
const specials = [
  "gender",
  "email",
  "nationality",
  "age",
  "dob",
  "gov_id",
  "internation_travel",
  "domestic_travel",
  "foreign_travel",
  "close_contact_corona_patient",
  "relationship_with_main_visitor",
  "body_temperature",
  "coughing",
  "doctor_certificate",
  "pass_affection",
  "terms_conditions",
  "signature",
  "vaccine_card"
];
const different = [
  "full_name",
  "first_name",
  "last_name",
  "age",
  "dob",
  "gender",
  "occupancy",
  "gov_id_number",
  "body_temperature",
  "address",
  "coughing",
  "doctor_certificate",
  "pass_affection",
  "prev_destination",
  "next_destination",
  "transportation",
  "internation_travel",
  "domestic_travel",
  "signature",
  "vaccine_card"
];
const canBeCopy = [
  "address",
  "coughing",
  "doctor_certificate",
  "pass_affection",
  "prev_destination",
  "next_destination",
  "transportation",
  "internation_travel",
  "domestic_travel",
  "foreign_travel",
  "close_contact_corona_patient"
];
const sameToAll = [
  "phone",
  "nationality",
  "email",
  "reservation_no",
  'terms_conditions',
  'signature'
];
const yesNo = [
  'coughing',
  'doctor_certificate',
  'pass_affection',
  'internation_travel',
  'domestic_travel',
];
const choices2 = [
  'foreign_travel',
  'close_contact_corona_patient'
];

// Modals that hand the screen to a payment gateway's own iframe (Digital
// Garage, fincode). Both card components use the first id; the second is the
// "processing" window that stands between sending the request and getting its
// result — the one stretch of the flow where the guest cannot act at all, and
// so must never be counted as an absent one (7. Session Management).
const PAYMENT_MODAL_IDS = ["payment-modal", "processing-modal"];

export default {
  components: {
    DateDropdown,
    Datepicker,
    TermsComponent,
    GuideComponent,
    preCheckinCustomForm,
    preCheckinBookingDetails,
    LanguageButtonComponent,
    localizedFilter,
    NationalityComponent,
    EmailComponent,
    AgeComponent,
    GenderComponent,
    DobComponent,
    GovIdComponent,
    BodyTemperatureComponent,
    CoreChoicesComponent,
    RelationshipComponent,
    DefaultComponent,
    SelectOptionModal,
    MultipleRoomComponent,
    ConfirmationSeparatelyModal,
    SignatureComponent,
    VaccineCardComponent,
    GatewayPayment,
    LeaveWarningModal,
    OptIn,
    MealComponent,
    CheckinByPhone,
    CheckinByName,
    CheckinTimeRestriction,
    CheckinByPciHub,
    CheckinKioskHub,
    KioskIdleWarningModal
  },
  mixins: [kioskValidationMixin],
  data() {
    return {
      // Someone is part-way through a search on the kiosk check-in hub, which
      // is a child of this page (see the hub's `guestIsEngaged`). The hub owns
      // the idle watch while it is up, so this page needs it only to know
      // whether the end of the operating window may close the kiosk now or
      // has to wait — a half-typed name is not an unattended tablet.
      kiosk_hub_busy: false,
      hideButton: false,
      test: "",
      typy: t,
      page: 1,
      submit_btn: "",
      error_msg: "",
      checkin_msg: false,
      checkinRestrictedMsg: "",
      confirm: false,
      email_exists: false,
      form_language: "",
      facility_names: [],
      mode: "create",
      specials,
      c_specials: specials.concat([
        "phone",
        "address",
        "prev_destination",
        "next_destination",
        "transportation",
      ]),
      facility: {
        name: "...",
      },
      facility_name: "...",
      user: {
        email: "",
      },
      visitor: {
        visitor_id: null,
        first_name: null,
        last_name: null,
        address: null,
        phone_number: null,
        nationality: null,
      },
      visitor_forms: {},
      companions: [],
      questions: [],
      gov_id_exist: true,
      gov_id_companion: {
        exist: true,
      },
      custom_text_setting: {
        title: '',
        header: '',
      },
      form_choice_temp: {
        ids: {},
      },
      booking_details: {
        data: {},
        total: 0,
      },
      is_custom: false,
      next: "",
      enabled_languages: [],
      is_localized: false,
      localized_filters: [],
      selected_localized_category: null,
      td: false,
      noQuestions: false,
      different,
      canBeCopy,
      sameToAll,
      yesNo,
      choices2,
      guestCount: 1,
      images: [],
      selected_option: '',
      multiple_data: [],
      reservation_no: null,
      reservation_no_query: null,
      mr_visible: false,
      currency: "",
      signature_exist: true,
      signature_written: false,
      vaccine_card_images: [],
      vaccine_card_exist: true,
      vaccine_card_companion: {
        exist: true,
      },
      timer: null,
      // For not displaying forms on initial load
      is_loading: false,
      template_is_loading: false,
      checkin_form_type: "",
      showPaymentGateway: false,
      guestCompanions: null,
      navigationConfirmed: false,
      isFormDirty: false,
      shareableLink: false,

      //meal reservation details
      mealDetails: {},
      mealSelectedSlots: {},
      mealBooking: {},
      facilityInfo: [],
      mealRooms: [],
      hasAvailableTables: true,
      showMealError: false,

      //checkin by phone or name
      action: '',

      isCheckinNotAvailable: false,
      checkinFromTimeDisplay: "",
      checkinToTimeDisplay: "",
      checkinDate: "",
    };
  },
  // Ahead of the first render: this document booted at the app-wide default of
  // `en`, and on the kiosk the language is whatever the guest picked on the
  // start screen, or Japanese. A screen that boots under the light loading
  // state paints as it goes, so setting this any later shows a frame of the
  // wrong language. `isKioskRoute($route)` rather than the `isKioskMode`
  // computed — computed properties do not exist this early in the lifecycle.
  beforeCreate() {
    if (isKioskRoute(this.$route)) applyKioskLanguage(this.$i18n);
  },
  created() {
    window.addEventListener('beforeunload', this.handleBeforeUnload, { capture: true });
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.$root.$off("bv::modal::show", this.kioskOnModalShow);
    this.$root.$off("bv::modal::hidden", this.kioskOnModalHidden);
  },
  updated() {
    this.getCheckinFormType();
  },
  async mounted() {
    // Guest Hub: this boot fires a dozen sequential requests, and the overlay
    // driven per-request would blink off between every pair of them over a
    // half-built screen. Hold it up for the whole boot instead, and drop it
    // once the screen the guest is meant to see is actually ready. Kiosk only
    // — the public check-in form keeps the per-request overlay it has always
    // had. Released in a `finally` so a failed boot cannot wedge the tablet.
    // A boot is a boot however the guest got here — a tapped start button, a
    // Back, a reload — so it raises the same loading screen every time.
    if (this.isKioskMode) loader.hold();

    try {
      this.$store.commit("checkin-site/confirmCardResponse", null);
      // await this.checkBrowser(); // DISABLE in app browser. Causing the camera scan not working properly
      await this.getCheckinFormType();

      // Set initial action based on route meta
      if (this.$route.meta.checkin_phone === true) {
        this.action = 'search_phone';
      } else if (this.$route.meta.checkin_name === true) {
        this.action = 'search_name';
      }

      this.facility = await this.$lionheart
        .post("/facility/list", { slug_name: this.$route.params.slug_name })
        .then((r) => this.catcher(r.data, "data[0].id", (r) => r.data[0]))
        .catch((e) => this.catcher(e));
      if (this.facility.error.has_error) return this.$router.push("/404");

      if ((this.$route.meta.checkin_phone === true || this.$route.meta.checkin_name === true) && !this.isKioskMode) {
         this.checkCheckinOperationSettings();
      }

      // Idle auto-reset needs the Guest Hub timings, and only the kiosk has
      // them; the public check-in / pre-check-in form is left exactly as it was.
      // Armed before the rest of the page loads so a guest who walks away during
      // a slow load is still counted.
      if (this.isKioskMode) {
        await this.kioskLoadConfig(this.facility.id);
        // The end of the check-in window is watched here rather than on the
        // hub: this page outlives it — the hub is torn down the moment a
        // booking matches — so the close can wait for a guest who already
        // crossed into the form instead of interrupting them.
        this.kioskWatchCheckinWindow(() => this.kioskCloseIfUnattended());
        this.kioskWatchPaymentScreen();
        // The pre-check-in route arrives already "in session", so the watcher
        // below — which only fires on a change — would never start it.
        if (this.kioskSessionInProgress) this.kioskStartIdleWatch();
      }

      this.guestLength();
      await this.getFixedGuestCountSetting(this.facility.id)

      /*--- MRS methods ----*/
      await this.fetchFacilityInMrs(this.facility.id);
      await this.checkAndFetchMeal();
      /* ----------- */

      const el = await this.$lionheart.post("/facility-setting/list", {
        facility_id: this.facility.id,
        name: "language",
        paginate: false,
      });

      if (el.data.total != 0)
        el.data.data[0].value.forEach((value, key) => {
          this.enabled_languages.push(value.code);
        });
      else this.enabled_languages.push("en", "ja");

    await this.$lionheart.post("/facility-question/init", {
      facility_id: this.facility.id,
    });

      if (this.$storage.has("visitor")) {
        this.visitor.visitor_id = this.$storage.get("visitor").id;
        await this.loadVisitor();
      }
      if (this.$refs.ddAge0 && this.$refs.ddAge0[0]) {
        this.loadAgeDropdown(
          this.visitor_forms,
          this.$refs.ddAge0[0].getAttribute("data-key")
        );
      }

      let touchdown = (this.$route.query.ref == "td" || this.$route.query.ref == "tdf");
      if (this.$route.query.ref && touchdown) this.td = true;
    
    await this.loadQuestions();

      // Guest Hub: the flow the guest pressed on the start screen decides the
      // status they leave in. Start Check-in and Confirm Pre Check-in finish the
      // check-in outright; Start Pre Check-in leaves the booking pre-checked-in
      // for the front desk, which is the default `td = false`.
      //
      // Set here rather than at submit because `td` also picks which custom
      // message this page shows (loadCustomTextSetting, called just below): a
      // Start Check-in guest greeted by the Pre Check-in wording would be told
      // the wrong thing about what they are doing.
      if (this.isKioskMode) this.td = this.isKioskCheckinFlow;

      this.is_custom = this.facility.facility_setting.length > 0 ? true : false;
      await this.checkLocalizedFilter();

      // onmounted
      this.loadCustomTextSetting(this.$i18n.locale, this.facility.id);
      // Update from grand child
      this.$root.$on('update_email_exist', (status) => {
        this.email_exists = status;
      })

      await this.getCurrency();
      this.trackOpenedPCIForm(this.facility.id);

      //  for trigerring via refs the add companion
      eventBus.$on('eventBusAddCompanion', (clickEvent) => {
        this.addNewCompanionEventBus(clickEvent);
      });
      eventBus.$on('eventBusRemoveCompanion', (companionId) => {
        this.removeCompanionEventBus(companionId)
      });

      this.loadToTop(); // after all loaded
    } finally {
      if (this.isKioskMode) loader.release();
    }
  },

  computed: {
    ...mapState('memorizedInputs', ['memorizedEmail', 'checkinFormType']),
    ...mapState("guest", [
      "numberOfGuest",
      "guestCountSetting",
      "fullName",
      "pass",
      "pmsCode",
      "userRemarks",
      "rsvNo",
      "roomNo"
    ]),

    showMainFormField() {
      // check if is QR checkin by phone or name
      if (this.isQrCheckinByPhone || this.isQrCheckinByName) {
        // check if pre check in dont show the fields
        if (this.isPreCheckIn) {
          return false;
        }
      }

      // Same on the kiosk: a pre-checked-in booking is confirmed, not filled in.
      if (this.isKioskConfirmScreen) return false;

      return true;
    },

    isQrCheckinByPhone() {
      return this.$route?.meta?.checkin_phone === true;
    },

    isQrCheckinByName() {
      return this.$route?.meta?.checkin_name === true;
    },

    isPciHub() {
      return this.$route?.meta?.checkin_pci_hub === true;
    },

    cameFromPciHub() {
      return this.$route?.query?.pci === 'true' && this.$route?.query?.back === 'true';
    },

    cameFromKioskHub() {
      return this.$route?.query?.kiosk === 'true' && this.$route?.query?.back === 'true';
    },

    // Which kiosk flow the guest started on the Guest Hub start screen. Read
    // straight off the URL so it survives the full page navigation the kiosk
    // uses between screens (8. Privacy — nothing is carried in memory).
    kioskFlow() {
      return this.isKioskMode ? (this.$route?.query?.flow ?? '') : '';
    },

    // The kiosk flows that end at CHECKED IN. `td` is what the API reads to
    // decide that (CheckinRepository@logBooking: no `td` means the booking is
    // saved as PRE CHECK-IN), so the flow the guest pressed has to reach it —
    // otherwise the Guest Hub's "Start Check-in" would quietly leave everyone
    // pre-checked-in.
    isKioskCheckinFlow() {
      return this.kioskFlow === KIOSK_FLOWS.START_CHECKIN
        || this.kioskFlow === KIOSK_FLOWS.CONFIRM_PRE_CHECKIN;
    },

    // The payment step offers "Skip for now" only while `touchdown` is
    // undefined, i.e. on a pre-check-in. The kiosk check-in flows carry no
    // `ref=td`, so they mark themselves here; Start Pre Check-in keeps it.
    paymentTouchdown() {
      if (this.$route.query.ref == "td") return true;
      if (this.isKioskMode && this.isKioskCheckinFlow) return true;
      return undefined;
    },

    // Confirm Pre Check-in has nothing to ask: the guest filled the
    // questionnaire at home. The page shows their booking and the payment step
    // only, and the Confirm button finishes it — the same screen check-in by
    // name / by phone already show for a pre-checked-in booking.
    isKioskConfirmScreen() {
      return this.$route?.meta?.checkin_kiosk_hub === true && this.isPreCheckIn;
    },

    // The kiosk check-in hub is a child of this page and runs an idle watch of
    // its own, so this page must not run a second one on top of it. Mirrors the
    // hub's own v-if in the template: once the guest has a booking the hub is
    // torn down, and everything after it — the localized filter, the form, the
    // confirmation, the payment — belongs to this component.
    kioskHubOnScreen() {
      return this.$route.meta.checkin_kiosk_hub === true
        && this.next !== 'localized-filters' && this.next !== 'checkin-form';
    },

    // A guest is in the middle of something this page owns. On the kiosk
    // pre-check-in route (checkin-core?kiosk=true) that is true from the first
    // screen: unlike the hub, it is not a landing page anyone can leave sitting
    // — a guest starts typing their name into it straight away.
    kioskSessionInProgress() {
      return this.isKioskMode && !this.kioskHubOnScreen;
    },

    // Nobody is mid-anything: not on this page's screens, and not part-way
    // through a search on the hub either. Deliberately separate from
    // `kioskSessionInProgress`, which hands the idle watch back and forth with
    // the hub and must stay false while the hub owns it — closing has the
    // opposite requirement, and an engaged hub is exactly what it must wait for.
    kioskUnattended() {
      return !this.kioskSessionInProgress && !this.kiosk_hub_busy;
    },

    isPreCheckIn() {
      const status = this.booking_details?.data?.[0]?.booking_status_id;
      return status && Number(status) === booking_status.pre_check_in;
    },


    guestIsPaid() {
      // const paidStatuses = [2,3,7,8,10,11];
      /*
      "pending" => 1,
      "paid" => 2,
      "refund" => 3,
      "paid_authorized" => 7,
      "paid_captured" => 8,
      "pay_at_reception" => 9,
      "credit_card_deposit" => 10,
      "paid_after_credit_card_deposit" => 11,
      "cancelled" => 6
      */

      const paidStatuses = [
        payment_status.paid,
        payment_status.refunded,
        payment_status.paid_authorized,
        payment_status.paid_captured,
        payment_status.credit_card_as_deposit,
        payment_status.paid_after_credit_card_deposit
      ];

      if (this.booking_details.data.length < 1) return false;
      return paidStatuses.includes(this.booking_details.data[0].payment_status_id);
    },
    showBackButton() {
      // Came from the PCI hub or the kiosk hub - show Back immediately so the guest can return to the hub
      if ((this.cameFromPciHub || this.cameFromKioskHub) && (this.$route.meta.checkin_phone === true || this.$route.meta.checkin_name === true)) {
        return true;
      }

      // Past the kiosk hub's own method list: Back returns to it (see back(),
      // CASE 0c). On the list itself the hub draws its own way home.
      if (this.$route.meta.checkin_kiosk_hub === true) {
        return this.next === 'checkin-form' || this.next === 'localized-filters';
      }

      // Check-in by phone case
      if (this.$route.meta.checkin_phone === true && this.action !== 'search_phone') {
        return true;
      }

      // Check-in by name case — no back within the single-step name form
      // but show back when navigated into the checkin-form
      if (this.$route.meta.checkin_name === true && (this.next === 'checkin-form' || this.next === 'localized-filters')) {
        return true;
      }

      // Normal check-in case
      if (this.is_custom && this.next === 'checkin-form' && !this.confirm && !this.template_is_loading) {
        return true;
      }

      return false;
    }
  },
  methods: {
    ...mapActions('guest', ['getGuestCount', "checkNextType", "saveFullName"]),
    ...mapActions('memorizedInputs', ["saveCheckinFormType"]),

    getChoice,
    formatDate,
    loadAgeDropdown,

    // Build the checkin-restricted message from the restriction info returned by the /checkin submission itself.
    setCheckinRestrictedMsg(guestResult) {
      const from = moment(guestResult.checkinFrom, "HH:mm").format("h:mm A");
      const to = moment(guestResult.checkinTo, "HH:mm").format("h:mm A");
      this.checkinRestrictedMsg = this.$t("visit-information-form.checkin_restricted_msg", { from, to });
    },

    async checkCheckinOperationSettings() {
      const timezonSetting = await this.$lionheart.get("v2/facility-settings", {
        params: {
          facility_id: this.facility.id,
          name: "timezone",
          paginate: 0,
        },
      });
      const timezone =
        timezonSetting.data.data.length > 0
          ? timezonSetting.data.data[0].value
          : "Asia/Tokyo";
      const checkinOperationSettings = await this.$lionheart.get(
        "v2/facility-settings",
        {
          params: {
            facility_id: this.facility.id,
            name: "checkin_operation_settings",
            paginate: 0,
          },
        }
      );
      const timing =
        checkinOperationSettings.data.data.length > 0
          ? checkinOperationSettings.data.data[0].value
          : { from: "00:00", to: "23:59" };

      // Check-in by name/phone searches by today's date, so it doesn't open during the after-midnight extension
      const { isInRange, fromDisplay, toDisplay, checkinDate } = checkCheckinTimeWindow(timing, timezone, { allowNextDay: false });

      this.checkinFromTimeDisplay = fromDisplay;
      this.checkinToTimeDisplay = toDisplay;
      this.isCheckinNotAvailable = !isInRange;
      this.checkinDate = checkinDate;
    },

    // call map room label api
    async mapRoomLabel(facilityId) {

      const payload = {
        "reservation_no": this.rsvNo,
        "pms_code": this.pmsCode,
        "pass": this.pass,
        "checkin_facility_id": facilityId
      }

      const response = await this.$lionheart.post('/meal-reservation/room-map-label', payload)

      let roomNumberRaw = response.data?.room_number ?? "";
      roomNumberRaw = String(roomNumberRaw).trim();

      let roomNumbers = [];

      if (roomNumberRaw) {
        roomNumbers = roomNumberRaw
          .split(/[,|]/)
          .map(r => r.trim())
          .filter(r => r !== "");
      }

      // handles the on prem facilities set room no
      if (roomNumbers.length === 0 && this.roomNo) {
        roomNumbers = this.roomNo;
      }

      this.mealRooms = roomNumbers;
    },

    async fetchFacilityInMrs(facilityId) {
      try {
        const response = await this.$mrsApi.get(`/facility?checkin_facility_id=${facilityId}`);
        this.facilityInfo = response.data;
      } catch (error) {
        console.error('Error fetching facility info:', error);
      }
    },

    mealSelection(selections) {
      this.mealSelectedSlots = selections;
    },

    async checkAndFetchMeal() {

      const reservationNo = this.rsvNo;
      const facilityId = this.facility?.id;
      const pass = this.pass;

      if (facilityId && pass && reservationNo) {
        await this.fetchMealDetails(reservationNo, facilityId, pass);
      }
    },

    async fetchMealDetails(rsvNo, facilityId, pass) {
      const payload = { reservation_no: rsvNo, facility_id: facilityId, pass: pass };

      try {
        const response = await this.$lionheart.get('/meal-reservation/meal', {
          params: payload
        });
        this.mealDetails = response.data;

        this.mapRoomLabel(facilityId);
      } catch (error) {
        console.error("Error fetching meal data:", error);
      }
    },

    isMrsDropdownFilled() {
      if (
        this.mealDetails?.hasMealData &&
        this.hasAvailableTables &&
        this.facilityInfo[0]?.status == "enabled" 
      ) {
        const isFilled = this.$refs.mealComponent.validateSelections();

        if (!isFilled) {
          console.log('Meal validation failed — stopping');
          return false;
        }

        return true;
      }

      return false;
    },

    clearMealError() {
      this.showMealError = false;
    },

    async checkMealSelectionAndReserve(mrsFilled) {

      if (
        this.facilityInfo[0]?.status == "enabled" &&
        this.hasAvailableTables &&
        mrsFilled
      ) {
        const payload = {
          meal_details: this.mealSelectedSlots,
          reservation_no: this.rsvNo,
          facility_id: this.facility.id,
          status: "reserved",
          room: this.mealRooms,
          remarks: this.userRemarks,
          pms_code: this.pmsCode,
          pass: this.pass,
          is_checker: true
        }

        const checkMrsTableAvailability = await this.$mrsApi.post('/cis-reservation', payload)
          .then((m) => this.catcher(m, "data", (m) => m.data))
          .catch((m) => this.catcher(m));

        return checkMrsTableAvailability;
      }
    },

    isFormVisible() {
      return this.next
    },

    handleInput(event) {
      const inputValue = event.target.value;
      const uploadImage = document.querySelectorAll('.media-box');

      this.isFormDirty =
        inputValue !== "" || uploadImage
          ? true : false;
    },

    handleBeforeUnload(event) {
      if (!this.navigationConfirmed && this.isFormVisible() === "checkin-form" && this.isFormDirty === true) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    },

    proceedLeaving(next) {
      this.navigationConfirmed = true;
      next();
    },

    confirmLeave() {
      this.navigationConfirmed = true;
      this.$bvModal.hide('leave-warning-modal');
      window.removeEventListener('beforeunload', this.handleBeforeUnload); // Unbind the event to allow navigation
      window.location.reload(); // Trigger page reload or navigation
    },

    stayOnPage() {
      // this.navigationConfirmed = false; // Reset confirmation
      this.$bvModal.hide('leave-warning-modal');
    },

    guestLength() {
      if (this.numberOfGuest) {
        this.guestCompanions = this.numberOfGuest
      }
    },

    getCheckinFormType() {

      if (this.checkinFormType == "") {
        this.checkin_form_type = "rsv"
      } else if (this.checkinFormType == 'rsv') {
        this.checkin_form_type = "rsv"
      } else {
        this.checkin_form_type = "walk-in"
      }
    },

    async getFixedGuestCountSetting(facilityId) {

      if (facilityId) {
        try {
          const response = await this.$lionheart.get("/v2/facility-settings/fix-guest-count", {
            params: {
              facility_id: facilityId
            }
          })

          this.getGuestCount(response.data.data)

        } catch (error) {
          console.error('Error fetching fixed guest count setting:', error);
        }
      }
    },

    async trackOpenedPCIForm(facilityId) {

      if (t(this.$route.query, 'tCode').isDefined) {
        if (this.$route.query.tCode != 'undefined') {
          await this.$lionheart.post("/v2/track/guest-activity", { trackingCode: this.$route.query.tCode, facilityId, action: 'clicked_link_pci_guide', metadata: null });
        }
      }

    },
    // move to the top 
    loadToTop() {
      this.$refs.loadToTop.scrollIntoView({
        behavior: 'smooth'
      })
    },

    // check if in-app browser
    async checkBrowser() {
      if (this.$route.query.ref) return;

      const hostname = window.location.hostname;
      const slug_name = this.$route.params.slug_name;
      const rid = this.$route.query?.rid ?? '';
      let queryParams = '';

      if (rid) {
        queryParams = `?rid=${rid}&ref=1`;
      } else {
        queryParams = `?&ref=1`;
      }

      if (navigator.userAgent.match(/Android/i)) {
        const intentUrl = `intent://${hostname}/${slug_name}/checkin-core${queryParams}#Intent;scheme=https;action=android.intent.action.VIEW;end`;

        window.location.href = intentUrl;
      } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        window.open(`https://${hostname}/${slug_name}/checkin-core${queryParams}`);
      }
    },
    async loadQuestions() {
      if (this.form_language == "") {
        const language = this.enabled_languages.find((item) => {
          if (item == this.$i18n.locale) return true;
          return false;
        }, this);
        this.form_language = language === undefined ? "en" : language;
      }

      const fac_name = this.facility.facility_name.find(
        (obj) => obj.language == this.$i18n.locale
      );
      const fac_name_en = this.facility.facility_name.find(
        (obj) => obj.language == "en"
      );

      if (this.$i18n.locale == "ja") {
        this.facility_name = this.facility_name = this.facility.name;
      } else if (fac_name === undefined) {
        if (fac_name_en) {
          this.facility_name = fac_name_en.name;
        } else {
          //fallback
          this.facility_name = this.facility.name;
        }
      } else {
        this.facility_name = fac_name.name;
      }
      if (this.selected_localized_category == null) {
        this.questions = await this.$lionheart
          .post("/facility-question/list", {
            facility_id: this.facility.id,
            language: this.form_language,
            ...(this.td ? { td: true } : { pre: true }),
          })
          .then((r) => r.data.data);
      } else {
        this.selectFilter(this.selected_localized_category, true);
      }

      return true;
    },
    async loadVisitor() {
      const visitor_id = this.visitor.visitor_id;
      const ve = ["created_at", "updated_at", "id", "user_id", "user"];
      const ue = [
        "created_at",
        "email_verified_at",
        "id",
        "updated_at",
        "name",
      ];
      let visitor = await this.$lionheart
        .post("/visitor/show", { id: visitor_id })
        .then((r) => r.data.data);
      let user = visitor.user;
      ve.map((obj) => delete visitor[obj]);
      ue.map((obj) => delete user[obj]);
      this.visitor.visitor_id = visitor_id;
      this.user = user;
    },
    async validateEmail() {
      const data = {
        email: this.user.email,
        id: this.visitor.visitor_id,
        type: "visitor",
        module: "checkin",
      };
      const email = await this.$lionheart
        .post("/user/exists", data)
        .then((r) => this.catcher(r.data, "data.exist", (r) => r.data))
        .catch((e) => this.catcher(e));
      if (email.error.has_error) return this.errorDisplay(email);
      this.email_exists = email.exist;
      this.$root.$emit('email_exists', email.exist); //Check email component
    },
    // The kiosk's one blocking loading state, and the reason it exists: from
    // here to the end of this method a guest's booking is being checked over
    // and written, and the overlay this raises carries the only sentence on the
    // tablet that matters while that runs — do not go back, do not refresh.
    // Wrapped around the whole method rather than around the submit call alone,
    // because the validation in front of it is just as uninterruptible and just
    // as slow: a card the payment gateway has to authorise before anything is
    // saved at all. Off the kiosk nothing changes; the site-wide overlay
    // already covers every request either half of this makes.
    async submitForm(e) {
      if (!this.isKioskMode) return this.runSubmitForm(e);

      loader.beginProcessing();
      try {
        return await this.runSubmitForm(e);
      } finally {
        loader.endProcessing();
      }
    },

    async runSubmitForm(e) {

      e.preventDefault();
      if (this.booking_details.total <= 1) {
        // Passport image validation
        if (
          this.questions.find(
            (el) => el.system_name == "gov_id" && el.required == 1
          )
        ) {
          this.gov_id_companion.exist = true;
          this.gov_id_exist = true;
          if (!this.hasPassportImage(this.visitor_forms)) {
            this.gov_id_exist = false;
            this.submit_btn = "";
            return false;
          }

          this.companions.forEach((value, key) => {
            if (
              !this.hasPassportImage(value.other_forms)
            ) {
              this.gov_id_companion = {
                exist: false,
                key: key,
              };
              this.submit_btn = "";
            }
          });

          if (!this.gov_id_companion.exist) {
            this.submit_btn = "";
            return false;
          }
        }

        // Vaccine card validation
        if (
          this.questions.find(
            (el) => el.system_name == "vaccine_card" && el.required == 1
          )
        ) {
          this.vaccine_card_companion.exist = true;
          this.vaccine_card_exist = true;
          if (!this.hasVaccineCard(this.visitor_forms)) {
            this.vaccine_card_exist = false;
            this.submit_btn = "";
            return false;
          }

          this.companions.forEach((value, key) => {
            if (
              !this.hasVaccineCard(value.other_forms)
            ) {
              this.vaccine_card_companion = {
                exist: false,
                key: key,
              };
              this.submit_btn = "";
            }
          });

          if (!this.vaccine_card_companion.exist) {
            this.submit_btn = "";
            return false;
          }
        }

        // Signature validation
        const sigElem = this.questions.find((el) => el.system_name == "signature");
        if (sigElem && sigElem.required == 1) {
          this.signature_exist = true;
          if (!this.hasSignature(this.visitor_forms)) {
            this.signature_exist = false;
            this.submit_btn = "";
            return false;
          }
        }
      }

      if (this.booking_details.total > 1) {
        this.multiple_data.forEach(item => {
          if (!item.filled_in_by_other) {
            // Passport image validation
            if (
              this.questions.find(
                el => el.system_name == "gov_id" && el.required == 1
              )
            ) {
              this.gov_id_companion.exist = true;
              this.gov_id_exist = true;
              if (!this.hasPassportImage(item.visitor_forms)) {
                this.gov_id_exist = false;
                this.submit_btn = "";
                return false;
              }

              item.companions.forEach((value, key) => {
                if (
                  !this.hasPassportImage(value.other_forms)
                ) {
                  this.gov_id_companion = {
                    exist: false,
                    key: key,
                  };
                  this.submit_btn = "";
                }
              });

              if (!this.gov_id_companion.exist) {
                this.submit_btn = "";
                return false;
              }
            }

            // Vaccine card validation
            if (
              this.questions.find(
                el => el.system_name == "vaccine_card" && el.required == 1
              )
            ) {
              this.vaccine_card_companion.exist = true;
              this.vaccine_card_exist = true;
              if (!this.hasVaccineCard(item.visitor_forms)) {
                this.vaccine_card_exist = false;
                this.submit_btn = "";
                return false;
              }

              item.companions.forEach((value, key) => {
                if (
                  !this.hasVaccineCard(value.other_forms)
                ) {
                  this.vaccine_card_companion = {
                    exist: false,
                    key: key,
                  };
                  this.submit_btn = "";
                }
              });

              if (!this.vaccine_card_companion.exist) {
                this.submit_btn = "";
                return false;
              }
            }

            // Signature validation
            if (this.questions.find((el) => el.system_name == "signature" && el.required == 1)) {
              this.signature_exist = true;
              if (!this.hasSignature(item.visitor_forms)) {
                this.signature_exist = false;
                this.submit_btn = "";
                return false;
              }
            }
          }
        });
      }
      if (this.submit_btn == "confirm" && this.email_exists == false) {

        const mrsCheckbox = this.$refs.mealComponent.noMealConfirmed;

        // MRS: check if all dropdowns selections are filled
        if (
          this.facilityInfo.length > 0 && 
          mrsCheckbox == false && 
          this.mealDetails?.hasMealData
        ) {
          
          const mrsFilled = this.isMrsDropdownFilled()

          if (!mrsFilled) {
            return;
          }

          // MRS: availability table checker
          const mrsCheckerResponse = await this.checkMealSelectionAndReserve(mrsFilled);

          // display generic error if failed
          if (mrsCheckerResponse.error.has_error) {
            return this.errorDisplay(mrsCheckerResponse)
          }

          // if slots full when confirm button is clicked
          if (mrsCheckerResponse.available_tables <= 0) {
            this.hasAvailableTables = false;
            this.showMealError = true;
          }

          // error meal display
          if (!this.hasAvailableTables) {
            if (!this.$refs.mealComponent.noMealConfirmed) {
              this.showMealError = true;
              return;
            } else {
              this.showMealError = false;
            }
          }
        }
      
        // fincode error validation
        const paymentComponent = this.$refs.gatewayPayment?.doCall?.();

        if (typeof paymentComponent?.validateBeforeConfirm === 'function') {
          paymentComponent.validateBeforeConfirm();
        }

        // Stripe payment component
        const status = await this.$refs.gatewayPayment.doCall().createPaymentMethod();
        if (!status) {
          return status;
        }
        this.confirm = true;
        this.error_msg = "";
        setTimeout(() => window.scrollTo(0, 10), 300);

        if (typeof paymentComponent?.proceedToSubmit === 'function') {
          paymentComponent.proceedToSubmit();
        }

        // To show confirmation alert
        if (this.booking_details.total > 1) {
          // To check if all forms are filled up
          const all_filled_up = this.multiple_data.every(function (data) {
            return data.filled_in_by_other == false
          })

          if (this.selected_option == 'separately' && !all_filled_up) {
            this.$bvModal.show('modal-confirmation-separately');
          }
        }
      }

      if (this.submit_btn == "edit") {
        this.reInitPayment();
      }

      if (this.submit_btn == "submit") {

          const mrsCheckbox = this.$refs.mealComponent.noMealConfirmed;

        // MRS: available tables checker for submit
         if (
          this.facilityInfo.length > 0 && 
          mrsCheckbox == false && 
          this.mealDetails?.hasMealData
        ) {
          const mrsFilled = this.isMrsDropdownFilled()

          const mrsCheckerResponse = await this.checkMealSelectionAndReserve(mrsFilled);

          if (mrsCheckerResponse.error.has_error) {
            this.$bvModal.hide('processing-modal')
            return this.errorDisplay(checkMrsTableAvailability);
          }

          if (mrsCheckerResponse.available_tables <= 0) {
            this.confirm = false;
            this.hasAvailableTables = false;
            this.showMealError = true;
          }

            // if available tables is not availble
          if (!this.hasAvailableTables) {
            // and no meal checkbox is not chekedd is not confirm
            if (!this.$refs.mealComponent.noMealConfirmed) {
              // back to confirm
              this.reInitPayment();
              return
              // else proceed with the submission
            }
          }

        }

        this.noQuestions = true;

        const visitor = this.visitor;
        const user = this.user;

        let visitor_forms = _.cloneDeep(this.visitor_forms);
        let companions = _.cloneDeep(this.companions);

        // If this form is accessed via Check-in by Phone/Name,
        // automatically set td = true so booking goes straight to "check-in" status.
        if (this.$route?.meta?.checkin_phone === true || this.$route?.meta?.checkin_name === true) {
          this.td = true;
        }

        // If accessed via PCI route (pci=true query param), also set td = true
        if (this.$route?.query?.pci === 'true') {
          this.td = false;
        }

        const dobObj = this.questions.find((obj) => {
          return obj.system_name == "dob";
        });

        const govidObj = this.questions.find((obj) => {
          return obj.system_name == "gov_id";
        });

        const vaccineCardObj = this.questions.find((obj) => {
          return obj.system_name == "vaccine_card";
        });

        let booking_details = this.booking_details.data;

        if (dobObj) {
          visitor_forms[dobObj.id] = moment(
            this.formatDate(visitor_forms[dobObj.id])
          ).format("YYYY-MM-DD");
        }

        if (govidObj) {
          if (visitor_forms[govidObj.id]) {
            visitor_forms[govidObj.id] = visitor_forms[govidObj.id].dataUrl;
          }
        }

        if (vaccineCardObj) {
          if (visitor_forms[vaccineCardObj.id]) {
            visitor_forms[vaccineCardObj.id] = visitor_forms[vaccineCardObj.id].dataUrl;
          }
        }

        companions = companions.map((obj) => {
          Object.entries(obj.other_forms).map((oc) =>
            oc[1] == null || undefined ? delete obj.other_forms[oc[0]] : ""
          );
          obj.other_forms = Object.entries(obj.other_forms).reduce(
            (a, [k, v]) => (v == "" ? a : ((a[k] = v), a)),
            {}
          );

          if (dobObj) {
            obj.other_forms[dobObj.id] = moment(
              this.formatDate(obj.other_forms[dobObj.id])
            ).format("YYYY-MM-DD");
          }

          if (govidObj) {
            if (obj.other_forms[govidObj.id]) {
              obj.other_forms[govidObj.id] =
                obj.other_forms[govidObj.id].dataUrl;
            }
          }

          if (vaccineCardObj) {
            if (obj.other_forms[vaccineCardObj.id]) {
              obj.other_forms[vaccineCardObj.id] =
                obj.other_forms[vaccineCardObj.id].dataUrl;
            }
          }

          return obj;
        });

        visitor_forms = Object.entries(visitor_forms).reduce(
          (a, [k, v]) => (v == "" ? a : ((a[k] = v), a)),
          {}
        );
        // this.hideButton = true; // this will prevent the duplication of payment esp. fincode

        // do this when submitting form (going to do 3d and checkin) then if error go back to input cards

        const payment = await this.$refs.gatewayPayment.doCall().makePayment(true);

        if (!payment) {
          this.confirm = false;
          setTimeout(() => this.$refs.gatewayPayment.doCall().reInit(), 300);
          return;
        };



        let data = [];
        this.shareableLink = false;
        if (this.booking_details.total > 1) {
          this.multiple_data.forEach((item, index) => {
            if (item.filled_in_by_other == false) {
              const booking = [];
              booking.push(booking_details[index]);

              if (govidObj) {
                if (govidObj.id in item.visitor_forms) {
                  item.visitor_forms[govidObj.id] = item.visitor_forms[govidObj.id].dataUrl;
                }
                item.companions.forEach((item, key) => {
                  if (govidObj.id in item.other_forms) {
                    item.other_forms[govidObj.id] = item.other_forms[govidObj.id].dataUrl;
                  }
                });
              }

              if (vaccineCardObj) {
                if (vaccineCardObj.id in item.visitor_forms) {
                  item.visitor_forms[vaccineCardObj.id] = item.visitor_forms[vaccineCardObj.id].dataUrl;
                }
                item.companions.forEach((item, key) => {
                  if (vaccineCardObj.id in item.other_forms) {
                    item.other_forms[vaccineCardObj.id] = item.other_forms[vaccineCardObj.id].dataUrl;
                  }
                });
              }


              data.push({
                facility_id: this.facility.id,
                timezone: moment.tz.guess(),
                companions: item.companions,
                ...visitor,
                ...user,
                email: item.email,
                other_form: item.visitor_forms,
                booking_details: booking,
                td: this.td,
              });
            }
          });

          // To check if all forms are filled up
          const all_filled_up = this.multiple_data.every(function (data) {
            return data.filled_in_by_other == false
          })

          if (this.selected_option == 'separately' && !all_filled_up) this.shareableLink = true;
        } else {
          // Normal checkin

          //check if there is memoized email

          if (this.memorizedEmail) {
            user['email'] = this.memorizedEmail;
          }

          data = [
            {
              facility_id: this.facility.id,
              timezone: moment.tz.guess(),
              companions,
              ...visitor,
              ...user,
              other_form: visitor_forms,
              booking_details,
              td: this.td,
            },
          ];
        }

        // console.log('form submit data', data)  // checkin incoming data
        console.log('meal form submit', this.mealSelectedSlots) // meal incoming selected data 

        // get the fullName of the guest
        const nameObj = this.questions.find((obj) => {
          return obj.system_name == "full_name";
        });

        // save the full name
        this.saveFullName(visitor_forms[nameObj.id]);

        if (
          this.mealDetails?.hasMealData &&
          this.facilityInfo[0]?.status == "enabled" &&
          this.facilityInfo.length > 0 &&
          this.hasAvailableTables
        ) {

          // if there is a meal reservation data run the MRS api
          const payload = {
            meal_details: this.mealSelectedSlots,
            reservation_no: this.rsvNo,
            facility_booking_id: null, // null at first
            facility_id: this.facility.id,
            status: "reserved",
            name: this.fullName,
            room: this.mealRooms,
            remarks: this.userRemarks,
            pms_code: this.pmsCode,
            pass: this.pass
          }

          // meal reservation api
          const mrsCheckin = await this.$mrsApi.post('/cis-reservation', payload, this.$bvModal.show('processing-modal'))
            .then((m) => {
              return this.catcher(m, "data", (m) => m.data);
            })
            .catch((m) => this.catcher(m));

          if (mrsCheckin.error.has_error) {
            this.$bvModal.hide('processing-modal')
            return this.errorDisplay(mrsCheckin);
          } else {
            // if no errors run the checkin api
            const checkinSubmit = await this.checkinSubmit(data);

            if (checkinSubmit.error.has_error) {

              // delete the meal reservations if checkin has errors
              await this.$mrsApi.delete('/reservations/cis-delete', {
                data: {
                  reservation_no: this.rsvNo,
                  pass: this.pass,
                  pms_code: this.pmsCode
                }
              }).then((m) => {
                return this.catcher(m, "data", (m) => m.data);
              })
                .catch((err) => {
                  console.error('Delete MRS reservations failed:', err?.response?.data?.message || err.message || err);
                  this.catcher(err);
                });

              // hide the processing modal and show the error message
              this.$bvModal.hide('processing-modal')
              return this.errorDisplay(checkinSubmit);

            } else {
              console.log('success no error in checkin with mrs');

              // proceed to get the booking id of the reservation 
              const params = {
                reservation_no: this.rsvNo,
                pms_code: this.pmsCode,
                pass: this.pass,
              }

              const checkinBooking = await this.$lionheart.get('/meal-reservation/booking-id', { params })
                .then((b) => {
                  return this.catcher(b, "data", (b) => b.data);
                }).catch((e) => {
                  this.catcher(e)
                });

              // pass the booking id to the meal reservations
              if (checkinBooking && checkinBooking?.data?.id) {

                const mrsUpdatePayload = {
                  reservation_no: this.rsvNo,
                  facility_booking_id: checkinBooking?.data?.id,
                  pms_code: this.pmsCode,
                  pass: this.pass
                };

                await this.$mrsApi.patch('/reservations/update-facility-booking-id', mrsUpdatePayload)
                  .then((b) => this.catcher(b, "data", (b) => b.data))
                  .catch((e) => this.catcher(e));

                if (!checkinSubmit[0].booking) {
                  this.$bvModal.hide('processing-modal');
                  if (checkinSubmit[0].checkinNotAvailable) this.setCheckinRestrictedMsg(checkinSubmit[0]);
                  setTimeout(() => window.scrollTo(0, $("#checkin_msg").position().top - 10), 300);
                  return (this.checkin_msg = true);
                }

                this.error_msg = "";

                // proceed to mypage
                this.myPageInit(checkinSubmit, user);
              }
            }
          }
        } else {
          // if no meal reservation do the regular checkin
          console.log('regular checkin');

          const checkin = await this.checkinSubmit(data);

          if (checkin.error.has_error) {
            this.$bvModal.hide('processing-modal')
            return this.errorDisplay(checkin);
          }

          console.log('checkin', checkin);

          if (!checkin[0].booking) {
            this.$bvModal.hide('processing-modal')
            if (checkin[0].checkinNotAvailable) this.setCheckinRestrictedMsg(checkin[0]);
            setTimeout(
              () => window.scrollTo(0, $("#checkin_msg").position().top - 10),
              300
            );

            return (this.checkin_msg = true);
          }

          this.error_msg = "";

          console.log('proceed to mypage');
          // proceed to mypage sync
          this.myPageInit(checkin, user);

        }
      }
    }, //  end for checkin submission method

    // method for re-initializing the payment 
    async reInitPayment() {
      console.log('trigger re Init');
      this.confirm = false;

      // fincode
      const paymentComponent = this.$refs.gatewayPayment?.doCall?.();

      if (typeof paymentComponent?.turnoffAlert === 'function') {
        paymentComponent.turnoffAlert();
      }

      setTimeout(() => this.$refs.gatewayPayment.doCall().reInit(), 300);
      window.scrollTo(0, 10);
    },

    // ---- Operating window (kiosk) ----------------------------------

    // Closing happens between guests, never through one. Anyone who started a
    // check-in before the window ended finishes it first — on the form, the
    // confirmation, the payment, or half-way through a search on the hub. The
    // close then lands when they are back on an untouched hub, or when the
    // idle auto-reset decides nobody is there (kioskAutoReset).
    kioskCloseIfUnattended() {
      if (!this.kiosk_close_pending) return;
      if (!this.kioskUnattended) return;

      this.kioskGoHome({ closing: true });
    },

    // ---- Payment screen (kiosk) ------------------------------------

    // The card form belongs to the payment gateway and runs in its own iframe,
    // so nothing the guest does while paying reaches this page — to the idle
    // timer, someone entering a card number is indistinguishable from an
    // abandoned tablet. Payment is also the one step that legitimately takes
    // minutes rather than seconds: a 3-D Secure challenge waits on an OTP that
    // has to arrive by SMS before the guest can type anything at all. So the
    // countdown does not run while the payment window is up; it starts over,
    // full length, once the guest is back on a screen the kiosk can watch.
    // Bootstrap's modal events are the one signal that does cross.
    kioskWatchPaymentScreen() {
      this.$root.$on("bv::modal::show", this.kioskOnModalShow);
      this.$root.$on("bv::modal::hidden", this.kioskOnModalHidden);
    },

    kioskOnModalShow(bvEvent, modalId) {
      if (!PAYMENT_MODAL_IDS.includes(modalId)) return;
      this.kioskSuspendIdleWatch();
    },

    kioskOnModalHidden(bvEvent, modalId) {
      if (!PAYMENT_MODAL_IDS.includes(modalId)) return;
      this.kioskResumeIdleWatch();
    },

    async myPageInit(checkin, user) {
      const queryParam = this.td ? { ref: "td" } : {};
      // this will check if the guest if from tablet mode
      if (this.$route.query.tab && this.$route.query.tab == 1) queryParam.tab = 1;

      let queryEmail = '';
      let queryPass = '';

      const isCheckinByPhone = this.$route.meta.checkin_phone;
      const isCheckinByName = this.$route.meta.checkin_name;
      const hasCustom = checkin[0] && checkin[0].custom === true;

      const emailParsed = this.typy(this.booking_details, 'data[0].parsed.email_address').safeString;
      const passParsed = this.typy(this.booking_details, 'data[0].pass').safeString;

      console.log('checkin', checkin);

      if (isCheckinByPhone || isCheckinByName) {
        queryEmail = emailParsed;
        queryPass = passParsed;

        // set the rsv query so get lock api will trigger
        this.reservation_no_query = this.booking_details.data[0]?.pms_reservation_no ?? null;

      } else if (hasCustom) {
        queryEmail = emailParsed || user.email;
        queryPass = passParsed || checkin[0].bookingDetails.pass;

      } else {
        // basic facility fallback
        queryEmail = emailParsed;
        queryPass = passParsed;
      }

      // The kiosk finds the booking itself (QR / name / email / reservation
      // no.) on the plain check-in route, so neither branch above hands the
      // success screen a reservation number — and without one it treats the
      // guest as a walk-in and never loads the stay dates it shows instead of
      // the pass. A real walk-in has no booking here and stays null.
      if (this.isKioskMode && !this.reservation_no_query) {
        this.reservation_no_query = this.booking_details?.data?.[0]?.pms_reservation_no ?? null;
      }

      console.log(this.reservation_no_query);

      const myPage = await this.$lionheart
        .get("/v2/facility-settings", {
          params: {
            name: 'my-page-setting',
            facility_id: this.facility.id,
            paginate: 0
          }
        })
        .then(res => res.data.data);


      let resultOfMyPage = myPage[0]?.value.active ?? false;


      let reservationNumberQuery = this.reservation_no_query ?? null
      // ONLY DISPLAY THE PASS, AS THERE IS A RULE THAT,
      // IF MYPAGE IS DISABLED, IT CAN'T BE ACCESSED
      if (resultOfMyPage) {
        queryParam.email = queryEmail;
      }
      queryParam.pass = queryPass;

      if (reservationNumberQuery) {
        queryParam.rsv_no = reservationNumberQuery;
        if (t(this.$route.query, 'tCode').isDefined) {
          queryParam.tCode = this.$route.query.tCode;
        }
      }

      // The success screen is the last screen of the kiosk flow and has to
      // know it: it drops the MyPage button (nobody signs in to a shared
      // tablet), shows the way back to the start screen instead, and keeps
      // the idle auto-reset running over the booking details it displays.
      if (this.isKioskMode) queryParam.kiosk = 'true';

      // Store localStorage
      this.$bvModal.hide('processing-modal')
      this.$router.push({
        name: "checkin-facility-checkin-success",
        params: {
          slug_name: this.$route.params.slug_name,
          show_shareable_link: this.shareableLink, // This will pop up shareable link modal
          rsv_no: reservationNumberQuery,
          email: queryEmail,
          pass: queryPass,
        },
        query: queryParam,
      });
    },

    // method for re-initializing the payment 
    async reInitPayment() {
      console.log('trigger re Init');
      this.confirm = false;

      // fincode
      const paymentComponent = this.$refs.gatewayPayment?.doCall?.();

      if (typeof paymentComponent?.turnoffAlert === 'function') {
        paymentComponent.turnoffAlert();
      }

      setTimeout(() => this.$refs.gatewayPayment.doCall().reInit(), 300);
      window.scrollTo(0, 10);
    },


    // checkin submission method
    async checkinSubmit(data) {
      const checkin = await this.$lionheart
        .post("/checkin", data, this.$bvModal.show('processing-modal'))
        .then((r) => {
          return this.catcher(r.data, "status", (r) => r.status);
        })
        .catch((e) => this.catcher(e));

      return checkin;
    },

    // method to trigger change language also call custom text setting
    async reloadQuestion(lang) {
      this.form_language = lang;
      this.$i18n.locale = lang;
      // On the kiosk this has to outlive the page: the screens further into
      // the flow are separate loads (see kiosk_language.js).
      if (this.isKioskMode) rememberKioskLanguage(lang);
      this.companions = [];
      this.page = 1;
      this.confirm = false;
      await this.loadQuestions();
      this.visitor_forms = {};

      if (this.$refs.ddAge0 && this.$refs.ddAge0[0]) {
        this.loadAgeDropdown(
          this.visitor_forms,
          this.$refs.ddAge0[0].getAttribute("data-key")
        );
      }
      this.loadCustomTextSetting(lang, this.facility.id);

      if (this.$refs.bookingDetailsComponent)
        this.$refs.bookingDetailsComponent.populate();
    },
    onPrev() {
      const found = Object.keys(this.questions).find((item) =>
        sections.includes(item)
      );
      if (!found) return (this.page = 1);
      return (this.page -= 1);
    },
    errorDisplay(d) {
      this.error_msg = d.error.msg;
      setTimeout(
        () => window.scrollTo(0, $("#error_msg").position().top - 10),
        300
      );
      return;
    },
    checkIfTAC() {
      var cond = {
        status: false,
      };

      if (this.questions) {
        this.questions.forEach((value, key) => {
          if (value.system_name == "terms_conditions") {
            cond.status = true;
            cond.id = value.id;
          }
        });
      }

      return cond;
    },
    setImage(data) {
      if (data == "main") {
        this.gov_id_exist = true;
      }
      if (data == "companion") {
        this.gov_id_companion.exist = true;
      }
    },
    //  loadcustom text
    async loadCustomTextSetting(lang, id) {
      let params;
      let response;
      this.custom_text_setting.title = '';
      this.custom_text_setting.header = '';

      if (this.is_custom && this.td == false) {
        params = {
          name: `message-precheckin-form-${lang}`,
          fallback: "message-precheckin-form-en",
        };
      }
      else {
        params = {
          name: `message-checkin-form-${lang}`,
          fallback: "message-checkin-form-en",
        };
      }

      response = await this.$lionheart.get("/custom-messages/" + id, {
        params: params,
      }).then(r => r.data.data);

      this.custom_text_setting = response.value ?? this.custom_text_setting;  //default value

      // Trigger if next page if is_localized = true
      if (this.next === 'localized-filters') {
        this.custom_text_setting.header = ''; //set header to null if localized select
        params = {
          name: `message-checkin-filter-form-${lang}`,
          fallback: "message-checkin-filter-form-en",
        };

        response = await this.$lionheart.get("/custom-messages/" + id, {
          params: params,
        }).then(r => r.data.data);

        this.custom_text_setting.header = response.value.header ?? '';
      }
    },
    async populate(obj) {
      obj.forms.forEach(
        (obj) => this.$set(this.visitor_forms, obj.id, obj.answer),
        this
      );
      this.user.email = obj.email;
      await this.validateEmail();
    },

    back() {
      // CASE 0: Came from the PCI hub - return to the hub instead of resetting in place
      // Full navigation (not $router.push): this route reuses the same MainHotelForm
      // instance as the hub, and Vue Router won't re-run mounted() on an in-place
      // route change, so the hub wouldn't get a fresh mount.
      if (this.cameFromPciHub && (this.$route.meta.checkin_phone === true || this.$route.meta.checkin_name === true)) {
        const { href } = this.$router.resolve({
          name: 'checkin-facility-checkin-pci-hub',
          params: { slug_name: this.$route.params.slug_name },
        });
        window.location.href = href;
        return;
      }

      // CASE 0b: Came from the kiosk hub - return to the kiosk hub (same full-navigation reason)
      if (this.cameFromKioskHub && (this.$route.meta.checkin_phone === true || this.$route.meta.checkin_name === true)) {
        const { href } = this.$router.resolve({
          name: 'checkin-facility-kiosk-checkin',
          params: { slug_name: this.$route.params.slug_name },
          query: { kiosk: 'true' },
        });
        window.location.href = href;
        return;
      }

      // CASE 0c: The kiosk hub lives on THIS route, so Back means reloading it
      // — which is also what drops the booking the guest was looking at, the
      // same clean slate every other kiosk navigation gives (8. Privacy). The
      // flow goes back in the URL so the hub comes up with the buttons the
      // guest pressed on the start screen, not a different set.
      if (this.$route.meta.checkin_kiosk_hub === true) {
        const { href } = this.$router.resolve({
          name: 'checkin-facility-kiosk-checkin',
          params: { slug_name: this.$route.params.slug_name },
          query: { kiosk: 'true', ...(this.kioskFlow ? { flow: this.kioskFlow } : {}) },
        });
        window.location.href = href;
        return;
      }

      // CASE 1: Check-in by phone back logic
      if (this.$route.meta.checkin_phone === true && this.action !== 'search_phone') {
        if (this.action === 'search_name') { // if on the seach of name then go back it will show the list of names
          this.$refs.checkinByNameComponent?.backToList();
          this.action = 'show_list_names';
          return;
        }
        this.$refs.checkinByPhoneComponent?.resetState();

        this.$nextTick(() => {
          this.action = 'search_phone';
          this.next = 'pre-checkin-form';
        });

        window.location.reload();
        return;
      }

      // CASE 1b: Check-in by name back logic
      if (this.$route.meta.checkin_name === true) {
        this.$refs.checkinByNameComponent?.resetState();

        this.$nextTick(() => {
          this.action = 'search_name';
          this.next = 'pre-checkin-form';
        });

        window.location.reload();
        return;
      }

      // CASE 2: Normal back logic
      if (this.isFormDirty) {
        this.$bvModal.show('leave-warning-modal');
      } else {
        window.location.reload();
      }
    },

    // validate payment
    async validatePayment() {
      if (!this.guestIsPaid) {

        // Validate Fincode
        const paymentComponent = this.$refs.gatewayPayment?.doCall?.();

        if (typeof paymentComponent?.validateBeforeConfirm === 'function') {
          paymentComponent.validateBeforeConfirm();
        }

        // Validate Stripe
        const status = await this.$refs.gatewayPayment.doCall().createPaymentMethod();
        if (!status) return status;
        this.error_msg = '';
        setTimeout(() => window.scrollTo(0, 10), 300);
      }
      return true;
    },

    // QR checkin by phone booking status is pre checkin ; submit for checkin if confirm button is clicked  
    // Same span, same reason as submitForm: this one validates and takes the
    // payment before it finishes the check-in.
    async submitFinishPreCheckin() {
      if (!this.isKioskMode) return this.runSubmitFinishPreCheckin();

      loader.beginProcessing();
      try {
        return await this.runSubmitFinishPreCheckin();
      } finally {
        loader.endProcessing();
      }
    },

    async runSubmitFinishPreCheckin() {

      // Guard: this completes checkin + takes payment. It must never run from the
      // PCI hub flow (?pci=true&back=true) — that flow only re-searches an already
      // pre-checked-in booking and should be blocked before reaching here.
      if (this.cameFromPciHub) return;

      console.log('finsih pre checkin');
      // Validate payment
      const paymentValid = await this.validatePayment();
      if (!paymentValid) return false;

      this.confirm = true; // set the form to confirm so input fields are disabled

      // Submit payment
      if (!this.guestIsPaid) {
        const payment = await this.$refs.gatewayPayment.doCall().makePayment(true);
        if (!payment) {
          this.confirm = false;
          setTimeout(() => this.$refs.gatewayPayment.doCall().reInit(), 300);
          return;
        };
      }

      const bookingData = this.booking_details.data[0];

      const payload = {
        pass: bookingData.pass,
        pms_code: bookingData.pms_code,
      }

      const checkin = await this.$lionheart
        .post("/facility-booking/finish-precheckin", payload, this.$bvModal.show('processing-modal'))
        .then((r) => this.catcher(r.data, "success", (r) => r.success))
        .catch((e) => this.catcher(e));

      if (checkin.error.has_error) {
        this.error_msg = error.msg;
        return;
      }

      // CI completion page
      this.myPageInit(bookingData, this.user);
    },

    // Guest Hub "Others": the guest has no reservation to look up, so the form
    // opens straight away and the API creates the booking at CHECKED IN. The
    // localized filter still applies — it decides which questionnaire they get.
    startKioskWalkIn() {
      this.booking_details = {};
      this.saveCheckinFormType("walk-in");
      this.next = this.is_localized ? "localized-filters" : "checkin-form";
      this.action = '';
      this.getCustomTextSetting();
    },

    //  check if the facility is capable of filtering local or international
    async checkLocalizedFilter() {
      const response = await this.$lionheart.post("/facility-setting/list", {
        facility_id: this.facility.id,
        name: "localized-filter",
        paginate: false,
      });

      if (response.data.total != 0) {
        if (response.data.data[0].value.visibility == true) {
          const lf = await this.$lionheart.get(
            "localized-filters?facility_id=" + this.facility.id // "localized-filters?facility_id=" + this.facility.id cors issue in apache
          );
          if (lf.data.data.length > 0) {
            this.is_localized = true;
            this.localized_filters = lf.data.data;
          }
        }
      }
      // Load the initial display.
      //
      // Only when nothing has moved the page on already. On the kiosk, a code
      // scanned on the start screen is handed to the check-in hub the moment
      // this page has a facility, so the hub's lookup can land the guest on
      // the form (`next = 'checkin-form'`) while this boot is still running
      // its remaining requests. Overwriting `next` here would then drop a
      // guest whose QR code was perfectly valid back onto the hub's search
      // methods (name / phone / email / reservation no.), with the booking
      // already found behind them.
      if (this.next) return;

      this.next =
        this.is_custom == true
          ? "pre-checkin-form"
          : this.is_localized == true
            ? "localized-filters"
            : "checkin-form";

    },

    //  function to get all questions based on facilityId
    async selectFilter(category, from, ci_mode) {
      this.selected_localized_category = category;
      const response = await this.$lionheart.post("/facility-question/list", {
        facility_id: this.facility.id,
        language: this.form_language,
        facilities_localized_category_id: category.id,
        ...(this.td ? { td: true } : { pre: true }),
      });

      if (response.data.total != 0) {
        this.questions = response.data.data;
        if (!from) this.updateMultipleData()
      }
      // trigger when selecting filter tag to get custom text setting
      this.getCustomTextSetting();
    },

    setVisitorImage(images) {
      this.images = images;
    },

    saveImages(obj, moveToTopActivated = false) {
      this.visitor_forms = obj.visitor_forms;
      this.companions = obj.companions;
      this.gov_id_exist = true;
      this.gov_id_companion.exist = true;
      if (moveToTopActivated && this.companions.length > 0) this.$refs.moveToTop.scrollIntoView({ behavior: 'smooth' });
    },

    retakeImage(obj) {
      this.images[obj.index].dataUrl = obj.dataUrl;
    },

    hasPassportImage(obj) {
      let question = this.questions.find(el => el.system_name == 'gov_id' && el.required == 1);
      return obj.hasOwnProperty(question.id);
    },

    showAlertModal() {
      this.$bvModal.show('leave-warning-modal');
    },

    leavePage() {
      window.removeEventListener("beforeunload", this.beforeUnloadHandler);
      //  this.$router.push(this.nextRoute); // Navigate to the intended route
    },

    stayOnPage() {
      this.isNavigatingAway = false;
      this.$bvModal.hide('leave-warning-modal');
    },

    retakeGovId(image) {
      if (image.index === 0) {
        this.visitor_forms[image.question_id] = {
          dataUrl: image.dataUrl,
        };
      } else {
        // if image.index is 0, it's for tour leader. Thus the minus one in index
        this.companions[image.index - 1].other_forms[image.question_id] = {
          dataUrl: image.dataUrl,
        };
      }
    },

    async updateMultipleData() {
      if (this.booking_details.total > 1) {
        this.next = "select-option";
        for (let i = 0; i < this.booking_details.total; i++) {
          this.multiple_data.push({
            visitor_forms: {},
            companions: [],
            guestCount: 1,
            email: '',
            filled_in_by_other: false,
            show: false,
          })
        }
      } else {
        this.next = "checkin-form";
      }
    },

    async updateMultipleFilledIn() {
      this.multiple_data.forEach((value, key) => {
        if (key != 0) value.filled_in_by_other = true
      });
    },

    async getCurrency() {
      try {
        const { data } = await this.$lionheart.get(
          `facility/${this.facility.id}/currency`
        );
        this.currency = data.value;
      } catch (error) {
        this.currency = "JPY";
        console.error(error.response.data.message);
      }

      this.showPaymentGateway = true;
    },

    hasSignature(obj) {
      let question = this.questions.find(el => el.system_name == 'signature' && el.required == 1);
      return obj.hasOwnProperty(question.id);
    },
    setVisitorVaccineCardImages(images) {
      this.vaccine_card_images = images;
    },
    retakeVisitorVaccineCardImage(obj) {
      this.vaccine_card_images[obj.index].dataUrl = obj.dataUrl;
    },
    hasVaccineCard(obj) {
      let question = this.questions.find(el => el.system_name == 'vaccine_card' && el.required == 1);
      return obj.hasOwnProperty(question.id);
    },
    clearSigError() {
      clearTimeout(this.timer);
      this.signature_exist = true;
      this.signature_written = false;
    },
    getCustomTextSetting() {
      this.loadCustomTextSetting(this.$i18n.locale, this.facility.id);
    },

    addNewCompanionEventBus(clickEvent) {
      this.$refs.defaultComponent[0].addCompanion(clickEvent);
      this.guestCount = this.images.length;
    },
    removeCompanionEventBus(companionIndex) {
      this.$refs.defaultComponent[0].removeCompanion(companionIndex);
      this.guestCount = this.images.length;
    },

    // when in main page there's a function that can remove companion
    handleRemoveCompanionUsingGovId(companionIndex) {
      this.$refs.defaultComponent[0].removeCompanion(companionIndex);
      this.images.splice(companionIndex + 1, 1)
      this.guestCount = this.images.length;
    }
  },
  beforeRouteLeave(to, from, next) {
    // Trigger custom modal when navigating within the app
    if (!this.navigationConfirmed) {
      this.proceedLeaving(next);
    } else {
      next();
    }
  },
  watch: {
    // Hands the idle watch back and forth with the kiosk check-in hub: the hub
    // holds it while it is on screen, this page from the moment it is gone.
    kioskSessionInProgress(active) {
      if (active) return this.kioskStartIdleWatch();
      this.kioskStopIdleWatch();
    },

    // The guest cleared the panel they were filling in and left the hub
    // untouched again, so a close that was waiting on them can happen.
    kiosk_hub_busy(busy) {
      if (busy) return;
      this.kioskCloseIfUnattended();
    },

    async next(val) {
      if (val) {
        setTimeout(() => {
          if (this.$refs.ddAge0 && this.$refs.ddAge0[0]) {
            this.loadAgeDropdown(
              this.visitor_forms,
              this.$refs.ddAge0[0].getAttribute("data-key")
            );
          }
        }, 100);
      }
    },

    signature_exist(yes) {
      if (!yes) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { this.signature_exist = true; }, 4000);
      }
    },
    facility: {
      handler() {
        this.checkAndFetchMeal();
      },
      deep: true
    },
    pass() {
      this.checkAndFetchMeal();
    },
    guestCountSetting() { },
    numberOfGuest(val) {
      if (val > 0) {
        this.guestCompanions = val;
      }
    },
    next() {
      this.isFormVisible();
    }
  },
};
